var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEzquant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_12_4",
    "data-name": "Component 12 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.65,
    height: 30.078,
    viewBox: "0 0 32.65 30.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M415.115,296.41v9.734l-7.678,9.734h-10.7l8.646-11.064H394.2a28.1,28.1,0,0,0-3.749-7.195,9.143,9.143,0,0,0-1.028-1.209Z",
    transform: "translate(-382.465 -296.41)",
    fill: "#35dcae"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M370.843,344.218v-9.734l7.678-9.734h10.7l-8.646,11.064h11.185a28.1,28.1,0,0,0,3.749,7.195,9.146,9.146,0,0,0,1.028,1.209Z",
    transform: "translate(-370.843 -314.14)",
    fill: "#36cbae"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzquant);
export default __webpack_public_path__ + "static/media/ezquant.1b381a5feca7c4333bdb51948acffa33.svg";
export { ForwardRef as ReactComponent };